
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import BookingRow from "@/views/booking/BookingRow.vue";

@Component({
  name: "Bookings",
  components: { BookingRow },
})
export default class Bookings extends Vue {
  grid = { page: 0, rows: null };
  url = "/api/booking/grid?sidx=startTime&sord=desc&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 20;
  fromDate = null;
  fromTime = null;
  tillDate = null;
  tillTime = null;
  bookingNo = null;
  client = null;

  paxCountryCode = null;
  paxPhone = null;
  bookerCountryCode = null;
  bookerPhone = null;
  dutySlipNo = null;
  driverCountryCode = null;
  driverPhone = null;
  driverName = null;
  clientEntity = null;
  vendorEntity = null;
  costCenter = null;
  paxName = null;
  bookerName = null;
  regNo = null;
  supplier = null;
  country = "";
  city = "";
  vehicleType = "";
  tariffType = "";
  tab = 1;
  upcomingCnt = 3;
  inserviceCnt = 2;

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url + "rows=" + this.rows);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    this.grid = await doGet(
      this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
    );
    common.setLoading(false);
  }

  async clear() {
    this.bookingNo = null;
    this.country = "";
    this.city = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.bookingNo) this.filterUrl += "&bookingNo=" + this.bookingNo;
    if (this.country) this.filterUrl += "&address.country=" + this.country;
    if (this.city) this.filterUrl += "&address.city=" + this.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async reload() {
    this.showPage(this.page);
  }

  async deleteCampus(campus) {
    common.setLoading(true);
    try {
      await doGet("/api/campus/" + campus._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
